/*
 * Copyright © 2017 - 2019 Atilika Inc. All rights reserved.
 */

import React, {memo} from "react";
import {Language} from "./Language";
import {Link} from "gatsby";
import {createUseStyles} from "react-jss";
import UI from "./UI";

const labels = {
    en: {
        home: "Home",
        services: "Services",
        products: "Products",
        company: "Company"
    },
    ja: {
        home: "ホーム",
        services: "サービス",
        products: "製品",
        company: "企業情報"
    }
};

const useStyles = createUseStyles({
    desktopLinks: {
        [UI.media.lte("sm")]: {
            display: "none"
        }
    },
    mobileLinks: {
        paddingTop: 50,
        "& a": {
            display: "block",
            color: UI.colors.white.toCSS(),
            fontFamily: UI.fonts.neoTechStd,
            fontSize: "2.5rem",
            fontWeight: 300,
            marginBottom: "3rem",
            textAlign: "center",
            width: "100%",
            paddingLeft: 0,
            "&:lang(ja)": {
                fontSize: "2rem"
            },
            "&:hover": {
                textDecoration: "none"
            }
        }
    }
});

interface NavigationLinksProps {
    type: "mobile" | "desktop";
    lang: Language;
    onVisit: () => void;
}

function NavigationLinks({onVisit, type, lang}: NavigationLinksProps) {
    const classes = useStyles();
    return (
        <div className={type === "mobile" ? classes.mobileLinks : classes.desktopLinks}>
            <Link onClick={onVisit} to={`/${lang}/`}>
                {labels[lang].home}
            </Link>
            <Link onClick={onVisit} to={`/${lang}/services/`}>
                {labels[lang].services}
            </Link>
            <Link onClick={onVisit} to={`/${lang}/products/`}>
                {labels[lang].products}
            </Link>
            <Link onClick={onVisit} to={`/${lang}/company/`}>
                {labels[lang].company}
            </Link>
        </div>
    );
}

export default memo(NavigationLinks);
